import $http from 'axios';

export class SessionSmsRepo {
  async refresh(clinicId: number) {
    return $http.post('/session_smses/refresh', {
      clinicId,
    });
  }
}
